/**
 * Turns a tab label into a stable key usable in the URL.
 * @function slugifyTabLabel
 * @since 1.0.0
 */
export function slugifyTabLabel(label) {
    return label
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
/**
 * Splits the tabs between the bar and the "More" menu. Tabs keep their
 * natural width, the ones that do not fit go in the menu, and the selected
 * tab always stays in the bar (it takes the place of the last ones).
 * @function computeVisibleTabs
 * @since 1.0.0
 */
export function computeVisibleTabs(widths, available, moreWidth, selectedIndex) {
    const all = widths.map((_, index) => index);
    // Not measured yet: show everything rather than flashing the menu
    if (available <= 0) {
        return { visible: all, overflow: [] };
    }
    const total = widths.reduce((sum, width) => sum + width, 0);
    if (total <= available) {
        return { visible: all, overflow: [] };
    }
    const budget = available - moreWidth;
    const visible = [];
    let used = 0;
    for (const index of all) {
        if (used + widths[index] > budget) {
            break;
        }
        visible.push(index);
        used += widths[index];
    }
    if (selectedIndex >= 0 && selectedIndex < widths.length) {
        if (visible.includes(selectedIndex) == false) {
            while (visible.length && used + widths[selectedIndex] > budget) {
                used -= widths[visible.pop()];
            }
            visible.push(selectedIndex);
        }
    }
    return {
        visible,
        overflow: all.filter((index) => visible.includes(index) == false)
    };
}
